/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useComponentMeta, useEntity } from '../helpers/selectors'
import LogoCollection from './logo-collection'
import { Link } from '../helpers/react'
import ImgixImg from '../helpers/ev-imgix'
import { path } from '../../utils/obj'

const ImgixImgConnected = ({ entity, ...props }) => {
  const { description, file, ...imageProps } = useEntity(entity)
  const aspectRatio = file?.details && file.details.image.height / file.details.image.width
  const width = props.width
  const height = props.height || (width && aspectRatio && width * aspectRatio)

  return (
    <ImgixImg
      {...props}
      {...imageProps}
      alt={description || imageProps.title}
      src={path(['url'], file)}
      width={width}
      height={height}
      sx={{ height: 'auto' }}
      aspectRatio={aspectRatio}
    />
  )
}

const Image = ({ image = {}, linkHref = '' }) => {
  const meta = useComponentMeta('collection', 'logos')

  return (
    <Choose>
      <When condition={linkHref}>
        <Link href={linkHref}>
          <ImgixImgConnected entity={image} {...meta.imageProps} />
        </Link>
      </When>
      <Otherwise>
        <ImgixImgConnected entity={image} {...meta.imageProps} />
      </Otherwise>
    </Choose>
  )
}

const ConnectedImage = (props) => {
  const entityProps = useEntity(props)
  return <Image {...props} {...entityProps} />
}

const CollectionImage = ({ entries, variant }) => (
  <LogoCollection
    variant={variant}
    logoImage={
      <For each='entry' of={entries} index='i'>
        <ConnectedImage key={i} {...entry} />
      </For>
    }
  />
)

export default CollectionImage
